/* src/app/attachment-view-feature/attachment-view-feature.component.scss */
/*# sourceMappingURL=attachment-view-feature.component.css.map */
